import { SegmentProperty } from '@/integrations/segment/enums/SegmentProperty';
import SegmentService from '@/integrations/segment/SegmentService';
import { OnboardingConsentPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingConsentPageCompletedEventTracking';
import { OnboardingConsentPageViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingConsentPageViewedEventTracking';
import { OnboardingContinueJourneyModalViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingContinueJourneyModalViewedEventTracking';
import { OnboardingJurisdictionCompletedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingJurisdictionCompletedEventTracking';
import { OnboardingJurisdictionViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingJurisdictionViewedEventTracking';
import { OnboardingNamePageCompletedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingNamePageCompletedEventTracking';
import { OnboardingNamePageViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingNamePageViewedEventTracking';
import { OnboardingWelcomeModalCompletedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomeModalCompletedEventTracking';
import { OnboardingWelcomeModalQuitEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomeModalQuitEventTracking';
import { OnboardingWelcomeModalViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomeModalViewedEventTracking.ts';
import { OnboardingWelcomePageCompletedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomePageCompletedEventTracking';
import { OnboardingWelcomePageViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomePageViewedEventTracking';
import { PaywallPaymentModalCompletedEventTracking } from '@/modules/auth/models/segmentevents/PaywallPaymentModalCompletedEventTracking';
import { PaywallPaymentModalUpgradeScreenSelectedEventTracking } from '@/modules/auth/models/segmentevents/PaywallPaymentModalUpgradeScreenSelectedEventTracking';
import { PaywallPaymentModalViewedEventTracking } from '@/modules/auth/models/segmentevents/PaywallPaymentModalViewedEventTracking';
import { SelfServeSignupPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageCompletedEventTracking';
import { SelfServeSignupPageViewedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageViewedEventTracking';
import { StandardTriageRecommendationPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageCompletedEventTracking';
import { StandardTriageRecommendationPageConsultationBookedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageConsultationBookedEventTracking';
import { StandardTriageRecommendationPageConsultationClickedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageConsultationClickedEventTracking';
import { StandardTriageRecommendationPageEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageEventTracking';
import { StandardTriageRecommendationPageSelectedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageSelectedEventTracking';
import { StandardTriageSituationPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageSituationPageCompletedEventTracking';
import { StandardTriageWarningPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageWarningPageCompletedEventTracking';
import { ViewedStandardTriageSituationPageEventTracking } from '@/modules/auth/models/segmentevents/ViewedStandardTriageSituationPageEventTracking';
import { ViewedStandardTriageWarningPageEventTracking } from '@/modules/auth/models/segmentevents/ViewedStandardTriageWarningPageEventTracking';
import { CookieKey } from '@/modules/core/app/constants/CookieKey';
import { PredefinedJurisdiction } from '@/modules/predefined/enums/PredefinedJurisdiction';
import { HasUrlTrackingSegmentMixin } from '/@/integrations/segment/mixins/HasUrlTrackingSegmentMixin';

export const HasStandardPlanOnboardingTrackingSegmentMixin = {
  mixins: [HasUrlTrackingSegmentMixin],
  methods: {
    initSignUpFormUrlTracking() {
      SegmentService.init(null);
      if (this.hasTrackingUrlParam()) {
        this.setTrackingCookie(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING);
      } else {
        this.setTrackingCookieFromObject(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
          [SegmentProperty.EMAIL]: this.email,
          [SegmentProperty.REDIRECTED_FROM]: null
        });
      }
    },
    updateLineOfBusinessPropertyInTrackingCookie(form) {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        [SegmentProperty.LINE_OF_BUSINESS]: form.lineOfBusiness
      });
    },
    dispatchSelfServeSignupPageViewedEventTracking() {
      SelfServeSignupPageViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchSelfServeSignupPageCompletedEventTracking(form) {
      this.updateEmailPropertyInTrackingCookie(form);
      this.updateBillingPlanIdPropertyInTrackingCookie(form);
      this.updateLineOfBusinessPropertyInTrackingCookie(form);

      SelfServeSignupPageCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    updateEmailPropertyInTrackingCookie(form) {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        [SegmentProperty.EMAIL]: form.email
      });
    },
    updateBillingPlanIdPropertyInTrackingCookie(form) {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        [SegmentProperty.BILLING_PLAN]: form.billingPlanId
      });
    },
    dispatchOnboardingWelcomePageViewedEventTracking() {
      OnboardingWelcomePageViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingWelcomePageCompletedEventTracking() {
      OnboardingWelcomePageCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    updateNamePropertyInTrackingCookie() {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        name: this.form.fullName
      });
    },
    dispatchOnboardingNamePageViewedEventTracking() {
      OnboardingNamePageViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingNamePageCompletedEventTracking() {
      this.updateNamePropertyInTrackingCookie();

      OnboardingNamePageCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingJurisdictionViewedEventTracking() {
      OnboardingJurisdictionViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingJurisdictionCompletedEventTracking() {
      this.updateJurisdictionPropertyInTrackingCookie();

      OnboardingJurisdictionCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    updateJurisdictionPropertyInTrackingCookie() {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        jurisdiction: PredefinedJurisdiction.getByKey(this.form.jurisdictionId, 'id').name
      });
    },
    dispatchViewedStandardTriageSituationPageEventTracking() {
      ViewedStandardTriageSituationPageEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchStandardTriageSituationPageCompletedEventTracking() {
      this.updateSelectionPropertyInTrackingCookie();

      StandardTriageSituationPageCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    updateSelectionPropertyInTrackingCookie() {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        selection: this.form.needs.join(',')
      });
    },
    dispatchStandardTriageRecommendationPageConsultationBookedEventTracking(type) {
      StandardTriageRecommendationPageConsultationBookedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING),
        type
      );
    },

    dispatchStandardTriageRecommendationPageCompletedEventTracking() {
      StandardTriageRecommendationPageCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },

    dispatchStandardTriageRecommendationPageConsultationClickedEventTracking(type) {
      StandardTriageRecommendationPageConsultationClickedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING),
        type
      );
    },
    dispatchStandardTriageRecommendationPageSelectedEventTracking() {
      StandardTriageRecommendationPageSelectedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchStandardTriageRecommendationPageEventTracking() {
      this.updateRecommendedProductPropertyInTrackingCookie();

      StandardTriageRecommendationPageEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    updateRecommendedProductPropertyInTrackingCookie() {
      this.appendTrackingCookieValues(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING, {
        recommended_product: this.form.recommendedBillingPlan
      });
    },
    dispatchViewedStandardTriageWarningPageEventTracking() {
      ViewedStandardTriageWarningPageEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchStandardTriageWarningPageCompletedEventTracking() {
      StandardTriageWarningPageCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingWelcomeModalViewedEventTracking() {
      OnboardingWelcomeModalViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchPaywallPaymentModalViewedEventTracking(clicked_from_url) {
      PaywallPaymentModalViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING),
        clicked_from_url
      );
    },
    dispatchPaywallPaymentModalCompletedEventTracking() {
      PaywallPaymentModalCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchPaywallPaymentModalUpgradeScreenSelectedEventTracking(clicked_from_url) {
      PaywallPaymentModalUpgradeScreenSelectedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING),
        clicked_from_url
      );
    },
    dispatchOnboardingContinueJourneyModalViewedEventTracking() {
      OnboardingContinueJourneyModalViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingWelcomeModalCompletedEventTracking() {
      OnboardingWelcomeModalCompletedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingWelcomeModalQuitEventTracking() {
      OnboardingWelcomeModalQuitEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingConsentPageViewedEventTracking() {
      OnboardingConsentPageViewedEventTracking.dispatch(
        this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING)
      );
    },
    dispatchOnboardingConsentPageCompletedEventTracking(hasConsentForPartnerToAccessEstateAccount) {
      OnboardingConsentPageCompletedEventTracking.dispatch({
        ...this.getDecodedTrackingCookieValue(CookieKey.ONBOARDING_STANDARD_EVENT_TRACKING),
        consent_advisor_access: hasConsentForPartnerToAccessEstateAccount
      });
    }
  }
};
